import { useState } from "react";
import Section from "../Section";
import httpClient from "../../custom-hooks/httpClient";
import { toast } from "react-toastify";
import NINVerificationStatus from "../NINVerificationStatus";
import { useDispatch, useSelector } from "react-redux";
import { setVerificationData } from "../../app-store/ninSlice";

function StartNINVerification() {
  const [nin, setNin] = useState("");
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const verificationData = useSelector((state) => state.nin.verificationData);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const value = e.target.value;
    if (!/^[0-9]*$/.test(value)) {
      return;
    }
    setNin(value);
    setAreFieldsSet(value.trim().length === 11);
  };

  const handleSubmit = async () => {
    if (!areFieldsSet) {
      return;
    }

    try {
      const { data } = await httpClient.get(
        `/nin/start?channel=web&nin=${nin}`
      );
      dispatch(setVerificationData(data));
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  return (
    <>
      {!verificationData ? (
        <Section
          title="Start NIN Verification"
          text="Please, provide your NIN to proceed."
        >
          <input
            className={`form-control ${nin.length > 0 && (nin.length === 11 ? "is-valid" : "is-invalid")}`}
            type="text"
            value={nin}
            onChange={handleChange}
            placeholder="Enter NIN"
            title="Numbers only"
            maxLength={11}
            aria-label="Enter your NIN"
          />

          <button
            className="btn w-100 btn-primary mt-6"
            type="button"
            onClick={handleSubmit}
            disabled={!areFieldsSet}
            aria-label="Submit NIN"
          >
            Submit
          </button>
        </Section>
      ) : (
        <NINVerificationStatus verificationData={verificationData} />
      )}
    </>
  );
}

export default StartNINVerification;
